// extracted by mini-css-extract-plugin
module.exports = {"modal1Content":"AilaCalendarAppointments_modal1Content__1SRIl","modal2Content":"AilaCalendarAppointments_modal2Content__1lsFs","heading":"AilaCalendarAppointments_heading__2XLB6"};